"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = exports.getFullIframeOptions = void 0;
var query_string_1 = __importDefault(require("query-string"));
var types_1 = require("./types");
exports.getFullIframeOptions = function () { return ({
    containerElement: document.body,
    className: '',
    size: {
        width: 375,
        height: 667,
    },
    position: {
        right: '0%',
        bottom: '0%',
    },
    protectAgainstGlobalStyleBleed: true,
}); };
var xButtonSize = '22px';
var globalStyleBleedProtection = "\n    /*\n    HARDEN STYLES TO PREVENT SOME GLOBAL STYLES FROM AFFECTING THEM\n    ----------------------------------------------------------------\n    This should solve issues that token trove are encountering.\n    */\n    .imxLinkIframeContainer__closeButton {\n        transition: none !important;\n        width: " + xButtonSize + " !important;\n        height: " + xButtonSize + " !important;\n        min-width: " + xButtonSize + " !important;\n        min-height: " + xButtonSize + " !important;\n        margin: 0 !important;\n        border: none !important;\n    }\n";
var renderEmbedStyles = function (_a) {
    var size = _a.size, position = _a.position, protectAgainstGlobalStyleBleed = _a.protectAgainstGlobalStyleBleed;
    return "\n    .imxLinkIframeContainer {\n        position: fixed;\n        " + (position.top ? "top: " + position.top + ";" : '') + "\n        " + (position.bottom ? "bottom: " + position.bottom + ";" : '') + "\n        " + (position.left ? "left: " + position.left + ";" : '') + "\n        " + (position.right ? "right: " + position.right + ";" : '') + "\n        width: " + size.width + "px;\n        height: " + size.height + "px;\n    }\n    .imxLinkIframeContainer__iframe {\n        display: block;\n        height: 100%;\n        width: 100%;\n        border: none;\n    }\n\n    .imxLinkIframeContainer__closeButton {\n        width: " + xButtonSize + ";\n        height: " + xButtonSize + ";\n        min-width: " + xButtonSize + ";\n        min-height: " + xButtonSize + ";\n        opacity: 0.4;\n        position: absolute;\n        z-index: 1;\n        top: 15px;\n        right: 15px;\n        background: transparent url(https://images.godsunchained.com/misc/white-menu-close.svg) center;\n        border: none;\n        padding: 0;\n        cursor: pointer;\n    }\n\n    " + (protectAgainstGlobalStyleBleed ? globalStyleBleedProtection : '') + "\n\n    .imxLinkIframeContainer__closeButton:hover {\n        opacity: 1;\n    }\n";
};
var Link = /** @class */ (function () {
    function Link(webUrl, iframeOptions) {
        var _this = this;
        if (webUrl === void 0) { webUrl = 'https://link.dev.x.immutable.com'; }
        if (iframeOptions === void 0) { iframeOptions = null; }
        this.webUrl = webUrl;
        this.iframeOptions = iframeOptions;
        this.openIframeOrWindow = function (route) {
            return function (params) {
                return _this.iframeOptions ? _this.openIframe(route, params) : _this.openWindow(route, params);
            };
        };
        this.openIframe = function (route, params) {
            return new Promise(function (resolve, reject) {
                var url = query_string_1.default.stringifyUrl({
                    url: _this.webUrl + "/" + route,
                    query: params ? params : {},
                });
                var unloadIframe = function () {
                    window.removeEventListener('message', eventListener, false);
                    fullIframeOptions.containerElement.removeChild(containerDom);
                    reject(new Error('Link iFrame Closed'));
                };
                var fullIframeOptions = __assign(__assign({}, exports.getFullIframeOptions()), _this.iframeOptions);
                var styleSheet = document.createElement('style');
                var containerDom = document.createElement('div');
                var iframeDom = document.createElement('iframe');
                var closeButtonDom = document.createElement('button');
                containerDom.classList.add('imxLinkIframeContainer');
                fullIframeOptions.className && containerDom.classList.add(fullIframeOptions.className);
                iframeDom.classList.add('imxLinkIframeContainer__iframe');
                iframeDom.setAttribute('sandbox', 'allow-same-origin allow-scripts allow-forms allow-popups');
                closeButtonDom.classList.add('imxLinkIframeContainer__closeButton');
                styleSheet.append(document.createTextNode(renderEmbedStyles(fullIframeOptions)));
                containerDom.append(styleSheet, iframeDom, closeButtonDom);
                closeButtonDom.addEventListener('click', unloadIframe);
                // @NOTE: set the source of the iframe, and finally inject the iframe
                // container into the document:
                iframeDom.setAttribute('src', url);
                fullIframeOptions.containerElement.appendChild(containerDom);
                var eventListener = function (event) {
                    var _a, _b;
                    if (event.origin !== _this.webUrl)
                        return;
                    var data = event.data;
                    if (data.type === types_1.LINK_MESSAGE_TYPE) {
                        switch (data.message) {
                            case types_1.messageTypes.inProgress: {
                                console.log(route + " In Progress");
                                break;
                            }
                            case types_1.messageTypes.success: {
                                console.log(route + " Succeeded", data.data);
                                resolve(((_a = data.data) !== null && _a !== void 0 ? _a : {}));
                                break;
                            }
                            case types_1.messageTypes.fail: {
                                console.log(route + " Failed");
                                reject();
                                break;
                            }
                            case types_1.messageTypes.result: {
                                console.log(route + " Succeeded with result", data.data);
                                resolve(((_b = data.data) !== null && _b !== void 0 ? _b : {}));
                                unloadIframe();
                                break;
                            }
                            case types_1.messageTypes.close: {
                                unloadIframe();
                                break;
                            }
                            default: {
                                console.error('Unknown message', data);
                                break;
                            }
                        }
                    }
                };
                window.addEventListener('message', eventListener, false);
            });
        };
        this.openWindow = function (route, params) {
            return new Promise(function (resolve, reject) {
                var url = query_string_1.default.stringifyUrl({
                    url: _this.webUrl + "/" + route,
                    query: params ? params : {},
                });
                var defaultOptions = exports.getFullIframeOptions();
                var win = window.open(url, 'imx-link', "menubar=yes,location=no,resizable=no,scrollbars=no,status=yes,width=" + defaultOptions.size.width + ",height=" + defaultOptions.size.height);
                if (!win) {
                    throw new Error('Unable to open window');
                }
                var checkClosed = setInterval(function () {
                    if (win.closed) {
                        clearInterval(checkClosed);
                        reject(new Error('Link Window Closed'));
                    }
                }, 500);
                var eventListener = function (event) {
                    var _a, _b;
                    if (event.origin !== _this.webUrl)
                        return;
                    var data = event.data;
                    if (data.type === types_1.LINK_MESSAGE_TYPE) {
                        switch (data.message) {
                            case types_1.messageTypes.inProgress: {
                                console.log(route + " In Progress");
                                break;
                            }
                            case types_1.messageTypes.success: {
                                console.log(route + " Succeeded", data.data);
                                resolve(((_a = data.data) !== null && _a !== void 0 ? _a : {}));
                                break;
                            }
                            case types_1.messageTypes.fail: {
                                console.log(route + " Failed");
                                reject();
                                break;
                            }
                            case types_1.messageTypes.result: {
                                console.log(route + " Succeeded with result", data.data);
                                window.removeEventListener('message', eventListener, false);
                                clearInterval(checkClosed);
                                win.close();
                                resolve(((_b = data.data) !== null && _b !== void 0 ? _b : {}));
                                break;
                            }
                            case types_1.messageTypes.close: {
                                window.removeEventListener('message', eventListener, false);
                                clearInterval(checkClosed);
                                win.close();
                                reject(new Error('Link Window Closed'));
                                break;
                            }
                            default: {
                                console.error('Unknown message', data);
                                break;
                            }
                        }
                    }
                };
                window.addEventListener('message', eventListener, false);
            });
        };
        this.history = this.openIframeOrWindow(types_1.Routes.History);
        this.setup = this.openIframeOrWindow(types_1.Routes.Setup);
        this.buy = this.openIframeOrWindow(types_1.Routes.BuyV2);
        this.sell = this.openIframeOrWindow(types_1.Routes.Sell);
        this.deposit = this.openIframeOrWindow(types_1.Routes.Deposit);
        this.prepareWithdrawal = this.openIframeOrWindow(types_1.Routes.PrepareWithdrawal);
        this.completeWithdrawal = this.openIframeOrWindow(types_1.Routes.CompleteWithdrawal);
        this.transfer = this.openIframeOrWindow(types_1.Routes.Transfer);
        this.cancel = this.openIframeOrWindow(types_1.Routes.Cancel);
    }
    return Link;
}());
exports.Link = Link;
